import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { Context } from '@service/context.service';
import { AbstractContentComponent } from '../abstract-content.component';
import { canReadHelp, HelpAudience } from './help.feature';

type HelpNavItem = { labelKey: string; link: string; children?: HelpNavItem[] };

@Component({
  selector: 'app-help',
  imports: [CardModule, RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe],
  templateUrl: './help.component.html',
  styleUrl: './help.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent extends AbstractContentComponent {
  readonly navItems: HelpNavItem[];

  constructor() {
    super(Context.Global, 'MENU.HELP');
    this.navItems = this.buildNavItems();
  }

  private buildNavItems = (): HelpNavItem[] => {
    const items: HelpNavItem[] = [{ labelKey: 'HELP.INTRODUCTION', link: '/hilfe' }];

    if (this.canRead('anwender')) {
      items.push({ labelKey: 'HELP.ANWENDER', link: '/hilfe/anwender' });
    }
    if (this.canRead('kis-partner')) {
      items.push({ labelKey: 'HELP.KIS_PARTNER', link: '/hilfe/kis-partner' });
    }
    if (this.canRead('softwarepartner')) {
      items.push({
        labelKey: 'HELP.SOFTWAREPARTNER',
        link: '/hilfe/softwarepartner',
        children: [
          { labelKey: 'HELP.MANUALS', link: '/hilfe/softwarepartner/handbuecher' },
          { labelKey: 'HELP.INTERFACE', link: '/hilfe/softwarepartner/schnittstelle' },
          { labelKey: 'HELP.WINDOWS_SERVICE', link: '/hilfe/softwarepartner/windows-service' },
        ],
      });
    }

    return items;
  };

  private canRead = (audience: HelpAudience): boolean => {
    return canReadHelp(this.authorizationService, audience);
  };
}
